// @ts-nocheck

import React, { useEffect, useState } from 'react'
import styles from './JeweleryarrivalAcceccories.module.scss'
import Slider from 'react-slick'
import { useSelector } from 'react-redux'
import { useAppDispatch } from 'src/store/store'
import { fetchModalData } from 'src/store/slices/manageModalSlice'
import { fetchMobileModalData } from 'src/store/slices/mobileModalSlice'
import { fetchProductByCategory } from 'src/store/slices/fetchAllProduct'

// const saveicon = '/assets/icon/save.png'
// const shareicon = '/assets/icon/share.png'
// const likeicon = '/assets/icon/like.png'

import Saveicon from 'public/assets/svg/Saveicon'
import Likeicon from 'public/assets/svg/Likeicon'
import Shareicon from 'public/assets/svg/Shareicon'
import { useRouter } from 'next/router'

// Custom arrow components for the slider
function SampleNextArrow(props) {
  const { className, style, onClick } = props
  return (
    <div className={className} onClick={onClick}>
      <img src="/assets/icon/right-icon-black.svg" alt="RightArrow" />
    </div>
  )
}

function SamplePrevArrow(props) {
  const { className, style, onClick } = props
  return (
    <div className={className} onClick={onClick}>
      <img src="/assets/icon/left-icon-black.svg" alt="LeftArrow" />
    </div>
  )
}

export default function JeweleryarrivalAcceccories({ category, subCategory, childSubCategory }) {
  const settings = {
    dots: true,
    infinite: false,
    speed: 500,
    slidesToShow: 4.7,
    slidesToScroll: 3,
    nextArrow: <SampleNextArrow />,
    prevArrow: <SamplePrevArrow />,
    centerMode: false,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          infinite: true,
          dots: false,
        },
      },
      {
        breakpoint: 700,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          initialSlide: 1,
          centerMode: false,
          dots: false,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2.2,
          slidesToScroll: 1,
          initialSlide: 1,
          centerMode: false,
          infinite: true,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 2.2,
          slidesToScroll: 1,
          centerMode: false,
          infinite: true,
        },
      },
    ],
  }
  const router = useRouter()
  const fetchMobileModal = useSelector((state: any) => state?.manageMobileModal?.data)
  const [products, setProducts] = useState<any>([])
  const [page, setPage] = useState(2)
  const [dataLimite, setDataLimite] = useState(10)
  const getAllState = useSelector((state: any) => state?.manageModalData?.data)
  const dispatch = useAppDispatch()

  const handleOpen = () => {
    dispatch(
      fetchModalData({
        allModalData: [
          ...getAllState?.allModalData,
          {
            modal: 'ShopnewArrivalSeeAll',
            isOpen: true,
            id: {
              title: 'New Arrival',
              description: 'New Arrival products! Dive in and discover what delights you',
              color: 'linear-gradient(90deg, #65459C 0%, #8C8894 100%)',
              category: category,
              subCategory: subCategory,
              childSubCategory: childSubCategory,
              isShopifyProduct: false,
              page: 1,
              limit: 30,
            },
            modalFor: 'bigModal',
          },
        ],
        lastModalData: getAllState?.lastModalData,
      }),
    )
  }

  const handleMobileOpen = () => {
    dispatch(
      fetchMobileModalData({
        allModalData: [
          ...(fetchMobileModal?.allModalData ? fetchMobileModal?.allModalData : []),
          {
            modal: 'mobileJewelryModal',
            isOpen: true,
            id: {
              title: 'New Arrival',
              description: 'New Arrival products! Dive in and discover what delights you',
              color: 'linear-gradient(90deg, #65459C 0%, #8C8894 100%)',
              image: '',
            },
            transform: 16,
          },
        ],
        lastModalData: fetchMobileModal?.lastModalData,
      }),
    )
  }

  useEffect(() => {
    dispatch(
      fetchProductByCategory({
        category: category,
        subCategory: subCategory,
        childSubCategory: childSubCategory,
        isShopifyProduct: false,
        page: page,
        limit: dataLimite,
      }),
    ).then((res) => {
      setProducts(res?.payload?.getAllProducts?.data)
    })
  }, [])

  return (
    <div>
      <div className={styles.JeweleryarrivalAcceccories}>
        <div className={styles.Jeweleryarrivalflxmain}>
          <div className={styles.Jeweleryarrivalitemsone}>
            <div>
              <h3>New Arrival</h3>
              {/* <p>Your Favorites, Always in the Loop</p> */}
              <p></p>
            </div>
            <div className={styles.Webmodalbutton}>
              <button onClick={() => handleOpen()}>See All</button>
            </div>
            <div className={styles.Mobilemodalbutton}>
              <button onClick={() => handleMobileOpen()}>See All</button>
            </div>
          </div>
          <div className={styles.Jeweleryarrivalitemstwo}>
            <Slider {...settings}>
              {products?.map((product, index) => {
                return (
                  <div>
                    <div
                      className={styles.Jeweleryarrivalsaliderboxmain}
                      onClick={() => {
                        router.push(`/product/${product?.slug}`)
                      }}
                    >
                      <div className={styles.Jeweleryarrivalsaliderbox}>
                        <img src={product?.images?.[0]?.src} alt="jewelryslide1" />
                        <div className={styles.sliderhover}>
                          <div className={styles.Sliderhoverinner}>
                            <div className={styles.Sliderhgovercontentone}>
                              <p>{product?.title}</p>
                              <span>${product?.dis_price || 0}</span>
                            </div>
                            <div className={styles.Sliderhgovercontenttwo}>
                              {/* <img src={saveicon} alt="saveicon" />
                              <img src={shareicon} alt="shareicon" />
                              <img src={likeicon} alt="likeicon" /> */}
                              <Saveicon />
                              <Shareicon />
                              <Likeicon />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                )
              })}
            </Slider>
          </div>
        </div>
      </div>
    </div>
  )
}
